import Vue from 'vue';

export class Relatorios{

    /**
     *
     * @return {Promise}
     */
    static gridGPSTravado(){
        return new Promise((ok, fail) => {
            Vue.http.get('v2/grid/gps_travado')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static gridOficina(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/oficina')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static gridRoubados(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/roubados')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static gridLogs(text){
        return new Promise((ok, fail) => {
            Vue.http.post('grid/logs', {
                text: text
            })
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static gridManutencao(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/manutencao')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static grid(){
        return new Promise((ok, fail) => {
            Vue.http.get('v2/grid/sem_transmissao')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static boletosVencidos(){
        return new Promise((ok, fail) => {
            Vue.http.get('v2/grid/boletos-vencidos')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static boletosPagos(mes, ano){
        return new Promise((ok, fail) => {
            Vue.http.get('v2/grid/boletos-pagos/' + mes + '/' + ano)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static boletosMensais(dia, mes, ano){
        return new Promise((ok, fail) => {
            Vue.http.get('v2/grid/boletos-mensais/' + dia + '/' + mes + '/' + ano)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static boletosNaoRegistrados(){
        return new Promise((ok, fail) => {
                Vue.http.get('v2/grid/boletos-nao-registrados')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static clientesSemCobranca(){
        return new Promise((ok, fail) => {
            Vue.http.get('v2/grid/financeiro/clientes/sem-cobranca')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static veiculoSemCobranca(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/v2/veiculos-sem-cobranca')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

}
